jQuery(document).ready(function ($) {
    $('.kg-products-owl').owlCarousel({
        loop: true,
        margin: 24,
        nav: true,
        dots: false,

        navText: [
        '<span class="owl-prev">&larr;</span>',
        '<span class="owl-next">&rarr;</span>'
        ],

        responsive: {
        0: {
            items: 1
        },
        480: {
            items: 1.2
        },
        768: {
            items: 2
        },
        992: {
            items: 3
        },
        1200: {
            items: 4
        }
        }
    });
});